export default __webpack_public_path__ + "images/adf57860b2a7fc2eabd52c38ebdc7bc9.png";